import React, { useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "react-use-cart";
import { IoMdClose } from "react-icons/io";
import style from "../../styles/cartDrawer.module.scss";
import { imageUrl } from "../../baseApi";
import { useCartDrawer } from "../../context/CartDrawerContext";
import { lineTotal, merchandiseTotal } from "../../utils/pricing";
import FreeShipping from "./FreeShipping";

const CartDrawer = () => {
  const { open, closeDrawer } = useCartDrawer();
  const { items } = useCart();
  const navigate = useNavigate();
  const location = useLocation();
  const skipClose = useRef(true);

  useEffect(() => {
    if (skipClose.current) {
      skipClose.current = false;
      return;
    }
    closeDrawer();
  }, [location.pathname, closeDrawer]);

  useEffect(() => {
    if (!open) return undefined;
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (event) => {
      if (event.key === "Escape") closeDrawer();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = previous;
      document.removeEventListener("keydown", onKey);
    };
  }, [open, closeDrawer]);

  if (!open) return null;

  const subtotal = merchandiseTotal(items);

  return (
    <>
      <button
        type="button"
        className={style.backdrop}
        aria-label="Mbyll shportën"
        onClick={closeDrawer}
      />
      <aside className={style.panel} role="dialog" aria-modal="true" aria-label="Shporta">
        <div className={style.head}>
          <h2>Shporta</h2>
          <button type="button" onClick={closeDrawer} aria-label="Mbyll">
            <IoMdClose size={24} />
          </button>
        </div>
        {items.length === 0 ? (
          <div className={style.empty}>
            <p>Shporta është bosh</p>
            <Link to="/shop" onClick={closeDrawer}>
              Shiko produktet
            </Link>
          </div>
        ) : (
          <ul className={style.list}>
            {items.map((item) => {
              const photo = item.photos?.[0]?.url;
              return (
                <li className={style.row} key={item.id}>
                  {photo ? (
                    <img src={`${imageUrl}${photo}`} alt="" />
                  ) : (
                    <span className={style.thumb} />
                  )}
                  <div className={style.info}>
                    <Link
                      to={item.slug ? `/shop/${item.slug}` : "/shop"}
                      onClick={closeDrawer}
                    >
                      {item.Title}
                    </Link>
                    <div className={style.meta}>
                      <span>× {item.quantity}</span>
                      <span>{lineTotal(item).toFixed(2)}€</span>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
        <div className={style.foot}>
          <FreeShipping />
          {items.length > 0 ? (
            <>
              <div className={style.subtotal}>
                <span>Nëntotali</span>
                <span>{subtotal.toFixed(2)}€</span>
              </div>
              <div className={style.actions}>
                <button
                  type="button"
                  className={style.checkout}
                  onClick={() => {
                    closeDrawer();
                    navigate("/cart");
                  }}
                >
                  Shko te shporta
                </button>
                <button type="button" className={style.continue} onClick={closeDrawer}>
                  Vazhdo blerjen
                </button>
              </div>
            </>
          ) : null}
        </div>
      </aside>
    </>
  );
};

export default CartDrawer;
